/**
 * The one Polaris empty-state illustration this app uses — hoisted here so
 * SyncHealth.tsx, Billing.tsx, and NotFound.tsx (three independent
 * `EmptyState image=` props before this) can't drift on the URL.
 */
export const EMPTY_STATE_IMAGE =
  'https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png';
